import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import perfil from 'views/components/mm_pro/empresa/store/perfil_empresa';
import solicitudes from 'views/components/mm_pro/empresa/store/solicitudes';
import solicitud from 'views/components/mm_pro/empresa/store/detalle_solicitud';
import contratadas from 'views/components/mm_pro/empresa/store/contratadas';
import llamadas from 'views/components/mm_pro/empresa/store/llamadas';
import buscador from 'views/components/mm_pro/empresa/store/buscador';
import notificaciones from 'views/components/mm_pro/empresa/store/notificaciones';
import { createStore } from 'vuex-extensions';

Vue.use(Vuex);

export default createStore(Vuex.Store, {
  modules: {
    store_perfil: perfil,
    store_solicitudes: solicitudes,
    store_detalle_solicitud: solicitud,
    store_contratadas: contratadas,
    store_llamadas: llamadas,
    store_buscador: buscador,
    store_notificaciones: notificaciones,
  },
  state: {
    empresa: {
      id: 0,
      token: '',
      historial_credito: {
        data: [],
      },
      pro_tablero: {
        num_sol_comprar: 0,
        num_sol_cotizar: 0,
        num_sol_confirmar: 0,
        num_sol_realizar: 0,
        num_sol_calificaciones: 0,
      },
    },
    numero_compras_o_membresias: -1,
  },
  getters: {
    getField,
  },
  mutations: {
    updateField,
  },
});
